import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { CourseInterface } from '@platri/df-common-core';
import {
  CoursesHttpService,
  DanceflavorsDanceManagerIdRouterParam,
  dfAppRoute,
  getSubscription
} from '@platri/dfx-angular-core';

@Component({
  selector: 'df-monorepo-iframe-dm-dance-courses-page',
  templateUrl: './iframe-dm-dance-courses-page.component.html',
  styleUrls: ['./iframe-dm-dance-courses-page.component.scss']
})
export class IframeDmDanceCoursesPageComponent implements OnInit, OnDestroy, AfterViewInit {
  subscriptions: Subscription =  new Subscription();

  isInitialized = false;
  isWaitingForDanceEventsResponse = false;
  hasErrorLoadingDanceEvents = false;
  hasFatalErrorOnInitialize = false;
  hasNonFatalErrorOnInitialize = false;

  routerParams!: Params;
  danceManagerIdFromParam: string;
  danceManagerUrlNameFromParam: string;
  backgroundColorFromQueryParam = '#FFFFFF';

  courses: CourseInterface[];

  isMobile = false;
  mediaQuery!: MediaQueryList;
  mediaQueryListener!: () => void;

  constructor(
    private readonly courseHttpService: CoursesHttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    console.log('Initialized IframeDmDanceEventsPageComponent');
  }

  ngOnInit(): void {
    this.mediaQuery = window.matchMedia('(max-width: 599px)');

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    this.mediaQueryListener = () => {
      console.log('IframeDmDanceCoursesPageComponent - ngOnInit -' +
        ' mediaQueryListener called');
      console.log('IframeDmDanceCoursesPageComponent - ngOnInit -' +
        ' mediaQueryListener is mobile: ' + this.mediaQuery.matches);
      this.isMobile = this.mediaQuery.matches;
      this.sendHeightToParent(); // Höhe bei Breakpoint-Wechsel neu senden
    };

    this.mediaQuery.addEventListener('change', this.mediaQueryListener);

    // Initial prüfen
    this.isMobile = this.mediaQuery.matches;
    
    this.initializeSubscriptions();
  }

  ngAfterViewInit(): void {
    this.sendHeightToParent();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.mediaQueryListener);
    }
  }

  initializeSubscriptions(): void {
    this.subscriptions.add(getSubscription(this.activatedRoute.params, this.onActivatedRouteParamsChanges.bind(this)));
    this.subscriptions.add(getSubscription(this.activatedRoute.queryParamMap, this.onActivatedRouteQueryParamsChanges.bind(this)));
  }

  onActivatedRouteParamsChanges(params: Params): void {
    this.routerParams = params;
    this.danceManagerUrlNameFromParam = this.routerParams[DanceflavorsDanceManagerIdRouterParam]?.replace('@', '');
    if (!this.danceManagerUrlNameFromParam) {
      this.router.navigate([dfAppRoute]);
    }
    this.loadData();
  }
  
  onActivatedRouteQueryParamsChanges(paramMap: ParamMap): void {
    if (paramMap.has('bg')) {
      this.backgroundColorFromQueryParam = '#' + paramMap.get('bg');
    }
  }


  loadData(): void {
    this.hasErrorLoadingDanceEvents = false;
    this.isWaitingForDanceEventsResponse = true;
    this.subscriptions.add(
      this.courseHttpService.getAllByDanceManagerUrlNameForPublicOverview(1, 100, this.danceManagerUrlNameFromParam).subscribe({
        next: (courses) => {
          this.courses = courses.results;
          this.isWaitingForDanceEventsResponse = false;
          this.isInitialized = true;
          this.sendHeightToParent();
        },
        error: (err) => {
          this.hasErrorLoadingDanceEvents = true;
          this.isWaitingForDanceEventsResponse = false;
        }
      })
    );
  }

  sendHeightToParent(): void {
    console.log('IframeDmDanceCoursesPageComponent - sendHeightToParent');
    const heightOfElement = this.isMobile ? 380 : 245;
    if (this.courses?.length > 0) {
      const height = heightOfElement * this.courses.length;
      window.parent.postMessage({type: 'setHeight', height}, '*');
    } else {
      window.parent.postMessage({type: 'setHeight', height: 500}, '*');
    }
  }
}
